<template>
  <div class="services-page container-fluid bg-light">
    <!-- First Row: Slideshow & Contact Info -->
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="carousel-container small-carousel">
            <ServiceCarousel :images="images" />
          </div>
        </div>
        <div class="col-md-4 contact-info text-center p-3">
          <h4 class="fw-bold">Need Assistance?</h4>
          <p class="mb-1">If you're going to reserve, fast call to:</p>
          <p class="mb-1">
            📞 <a href="tel:+393806852464" class="text-orange">0039 3806852464</a> |
            📱 <a href="https://wa.me/393806852464" class="text-orange">WhatsApp</a>
          </p>
          <p>Poyan will help you to have them very easily.</p>
        </div>
      </div>
    </div>

    <!-- Second Row: Service Cards -->
    <div class="container py-5">
      <h2 class="text-center fw-bold text-orange">Choose Your Ride</h2>
      <div class="row justify-content-center">
        <div class="col-12 mb-4" v-for="(service, index) in services" :key="index">
          <ServiceCard 
            :title="service.title" 
            :description="service.description"
            :img-src="service.image"
            :link="`/services/${service.slug}`"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/assets/services.json';
import ServiceCarousel from '@/components/ServiceCarousel.vue';
import ServiceCard from '@/components/ServiceCard.vue';

export default {
  components: {
    ServiceCarousel,
    ServiceCard
  },
  data() {
    return {
      images: [
        "/images/service1-1.jpg",
        "/images/service1-2.jpg",
        "/images/service1-3.jpg",
        "/images/service1-4.jpg",
        "/images/service1-5.jpg",
        "/images/service1-30.jpg",
        "/images/service2-1.jpg",
        "/images/service2-20.jpg",
        "/images/service2-2.jpg",
        "/images/service3-1.jpg",
        "/images/service3-2.jpg"
      ],
      services // ← loaded from imported JSON
    };
  }
};
</script>

<style scoped>
.services-page {
  width: 100%;
  overflow-x: hidden;
}

.carousel-container {
  height: 35rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-info {
  background: white;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 20px;
  color: black;
}

.text-orange {
  color: #f26522;
}

.card {
  transition: transform 0.3s ease-in-out;
}

.card:hover {
  transform: scale(1.05);
}
</style>
